<template>
  <div class="teacher">
    <Form ref="optionForm" :model="searchCondition" :label-width="70" inline>
      <FormItem label="助教名称">
        <Input
          v-model="searchCondition.real_name"
          placeholder="请输入助教关键字"
          style="width:200px;"
          clearable
          @keydown.native.prevent.enter="onSearch"
        ></Input>
      </FormItem>
      <FormItem label="手机号">
        <Input
          type="number"
          v-model="searchCondition.mobile"
          placeholder="请输入手机号"
          style="width:200px;"
          clearable
          @keydown.native.prevent.enter="onSearch"
        ></Input>
      </FormItem>
      <FormItem label="审核状态">
        <EnumSelect
          type="ApprovalStatus"
          v-model="searchCondition.approval_status"
          selector="select"
          style="width:200px"
        ></EnumSelect>
      </FormItem>
      <FormItem class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="onSearch">搜索</Button>
          <Button icon="md-undo" @click="onReset">重置</Button>
        </div>
      </FormItem>
    </Form>
    <div>
      <Button type="primary" @click="onAdd" class="btn-margin-right">新增助教</Button>
      <Button type="primary" @click="onImport()" class="btn-margin-right">批量导入</Button>
      <Button type="primary" @click="onExport('all')" class="btn-margin-right">批量导出</Button>
      <Button type="primary" @click="onWatch" class="btn-margin-right">查看报表</Button>
    </div>
    <div class="content">
      <Grid
        ref="grid"
        :columns="tableColumns"
        data-url="/api/assistant"
        :search="searchCondition"
        :rowsFormatter="onrowsFormatter"
        @onSelectionChange="onSelectionChange"
        selectType="multi"
        keyField="id"
        method="get"
      >
        <template slot-scope="{row}" slot="c1">
          <div class="vmiddle">
            <img class="table-avatar" :src="row.avatar" />
            <span v-text="row.real_name"></span>
          </div>
        </template>
        <template slot-scope="{row}" slot="action">
          <div>
            <Button type="text" size="small" @click="onApproval(row)">审核</Button>
            <span>-</span>
            <Button type="text" size="small" @click="onDetail(row)">详情</Button>
            <span>-</span>
            <Button type="text" size="small" @click="onEdit(row)">编辑</Button>
            <span>-</span>
            <Button type="text" size="small" @click="onResetPwd(row)">重置密码</Button>
            <span>-</span>
            <Button type="text" size="small" @click="onDelete(row)">删除</Button>
          </div>
        </template>
        <template slot="footer-left">
          <Button class="btn-margin-right" type="text" @click="onDelete('select')">删除所选</Button>
          <Button class="btn-margin-right" type="text" @click="onExport('select')">导出所选</Button>
        </template>
      </Grid>
    </div>
    <ExportsModal
      title="导出助教"
      :type="5"
      :params="exportForm"
      v-model="showExportModal"
      @onSuccess="onWatch"
    ></ExportsModal>
    <Modal v-model="showApprovalModal" title="处理审核">
      <div style="display:flex;">
        <!-- <div style="margin-right:15px;">
          <i class="ivu-icon ivu-icon-ios-alert" style="color: #f90;font-size:30px;"></i>
        </div>-->
        <div style="flex-grow:1;">
          <Form ref="approvalForm" :model="approvalForm" :label-width="70">
            <div class="flex-vc" style="margin-bottom:24px;">
              <div style="width:70px;text-align:center;">
                <img :src="current.avatar" class="table-avatar" />
              </div>
              <span>{{current.real_name}}</span>
            </div>
            <FormItem label="手机号">
              <span>{{current.mobile}}</span>
            </FormItem>
            <FormItem label="审核意见" prop="approval_status">
              <RadioGroup v-model="approvalForm.approval_status">
                <Radio label="3">
                  <span>拒绝</span>
                </Radio>
                <Radio label="2">
                  <span>通过</span>
                </Radio>
              </RadioGroup>
            </FormItem>
            <FormItem label="备注信息" prop="approval_failed_message">
              <Input
                v-model="approvalForm.approval_failed_message"
                size="large"
                type="textarea"
                :rows="6"
                :placeholder="approvalForm.approval_status=='2'?'请输入备注信息，选填':'请输入拒绝原因，必填'"
              />
            </FormItem>
          </Form>
        </div>
        <div style="clear:both;"></div>
      </div>
      <template v-slot:footer>
        <Button type="text" @click="showApprovalModal=false">取消</Button>
        <Button type="primary" @click="submitApproval">确定</Button>
      </template>
    </Modal>
  </div>
</template>

<script>
import { ApprovalStatus } from "../../utils/enums.js";
import ExportsModal from "@/components/ExportsModal";

export default {
  name: "AssistTeacher",
  components: {
    ExportsModal
  },
  data() {
    return {
      searchCondition: {
        real_name: "",
        mobile: "",
        approval_status: "",
        init: function() {
          this.real_name = "";
          this.mobile = "";
          this.approval_status = "";
        }
      },
      tableColumns: [
        { title: "助教名称", slot: "c1", minWidth: 200 },
        { title: "手机号", key: "mobile", align: "center", minWidth: 150 },
        { title: "班级", key: "count", align: "center", minWidth: 100 },
        {
          title: "审核状态",
          key: "approval_status_name",
          align: "center",
          minWidth: 100
        },
        {
          title: "更新时间",
          key: "updated_at",
          align: "center",
          minWidth: 150
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          minWidth: 200,
          fixed: "right"
        }
      ],
      selectRows: [],
      showExportModal: false,
      exportForm: {},
      teacher_default_pass: "",
      showApprovalModal: false,
      current: {},
      approvalForm: {
        approval_status: "",
        approval_failed_message: ""
      }
    };
  },
  created() {
    this.$http.get("/api/commonSetting").then(data => {
      this.teacher_default_pass = data.teacher_default_pass;
    });
  },
  methods: {
    onrowsFormatter(rows) {
      rows.forEach(i => {
        i.updated_at = this.$pub.timestampToTime(i.updated_at);
        i.approval_status_name = ApprovalStatus.getValue(i.approval_status);
      });
    },
    onSelectionChange(items) {
      this.selectRows = items;
    },
    onSearch() {
      this.$refs.grid.searchRefresh();
    },
    onReset() {
      this.searchCondition.init();
      this.$refs.grid.searchRefresh();
    },
    onAdd() {
      this.$router.push({
        name: "AssistTeacherEdit"
      });
    },
    onImport() {
      this.$router.push({
        name: "AssistTeacherImport",
        query: {
          type: "assist"
        }
      });
    },
    onExport(row) {
      if (row == "select") {
        if (this.selectRows.length == 0) {
          this.$Message.info("请选择要导出的助教");
          return;
        }
        const idAry = [];
        this.selectRows.forEach(i => {
          idAry.push(i.id);
        });
        this.exportForm.id = idAry.join();
      } else if (row == "all") {
        this.exportForm.real_name = this.searchCondition.real_name;
        this.exportForm.mobile = this.searchCondition.mobile;
        this.exportForm.approval_status = this.searchCondition.approval_status;
      }
      this.showExportModal = true;
    },
    onWatch() {
      this.$router.push({
        name: "AssistTeacherExport",
        query: {
          type: "assist"
        }
      });
    },
    onDetail(row) {
      this.$router.push({
        name: "AssistTeacherDetail",
        query: {
          id: row.id
        }
      });
    },
    onEdit(row) {
      this.$router.push({
        name: "AssistTeacherEdit",
        query: {
          id: row.id
        }
      });
    },
    onResetPwd(row) {
      this.$Modal.confirm({
        title: "提示",
        content:
          "密码将重置为" +
          this.teacher_default_pass +
          "，请提醒用户及时修改密码。",
        onOk: () => {
          this.$http.put("/api/assistant/resetPassword/" + row.id).then(() => {
            this.$Message.success("密码重置成功！");
          });
        }
      });
    },
    async onDelete(row) {
      let ids = "";
      if (row == "select") {
        if (this.selectRows.length == 0) {
          this.$Message.info("请选择要删除的助教");
          return;
        }
        const idAry = [];
        this.selectRows.forEach(i => {
          idAry.push(i.id);
        });
        ids = idAry.join();
      } else {
        if (row.count > 0) {
          this.$Modal.warning({
            title: "提示",
            content: "当前有助教已有所属班级，无法删除"
          });
          return;
        }
        ids = row.id;
      }
      await this.$promiseConfirm(
        row == "select" ? "确定要删除选定助教吗？" : "确定要删除该助教吗？",
        "提示"
      );
      await this.$http.delete("/api/assistant/" + ids);
      this.$Message.success("删除成功");
      this.$refs.grid.refresh();
    },
    onApproval(row) {
      this.approvalForm.approval_status =
        (row.approval_status == 2 ? 2 : 3) + "";
      this.approvalForm.approval_failed_message =
        row.approval_failed_message || "";
      this.current = row;
      this.showApprovalModal = true;
    },
    async submitApproval() {
      if (this.approvalForm.approval_status == "") {
        this.$Message.warning("请选择审核意见");
        return;
      }
      if (
        this.approvalForm.approval_status == 3 &&
        this.approvalForm.approval_failed_message == ""
      ) {
        this.$Message.warning("请输入拒绝原因");
        return;
      }
      await this.$http.put("/api/assistant/checkApproval/" + this.current.id, {
        approval_status: this.approvalForm.approval_status,
        approval_failed_message: this.approvalForm.approval_failed_message
      });
      this.$Message.success("审核成功");
      this.$refs.grid.refresh();
      this.showApprovalModal = false;
    }
  }
};
</script>
